import { render } from "./ProTag.vue?vue&type=template&id=5bad0e5f"
import script from "./ProTag.vue?vue&type=script&lang=js"
export * from "./ProTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/ProTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bad0e5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bad0e5f', __exports__)) {
    api.reload('5bad0e5f', __exports__)
  }
  
  module.hot.accept("./ProTag.vue?vue&type=template&id=5bad0e5f", () => {
    api.rerender('5bad0e5f', render)
  })

}


export default __exports__